export default "__VITE_ASSET__233a4d71__"